import { MultipleChoiceQuestion } from '../applicant/NewApplicationWizard/MultipleChoiceQuestion';
import { MultipleChoiceQuestionUIConfig } from '../../shared/MultipleChoiceQuestionUIConfig';

export interface MandatoryQuestionsToAskProps {
	uiConfig: MultipleChoiceQuestionUIConfig[];
}

export const MandatoryQuestionsToAsk = ({
	uiConfig,
}: MandatoryQuestionsToAskProps) => {
	const mandatoryQuestions = uiConfig.map(
		(question: MultipleChoiceQuestionUIConfig) => (
			<div key={question.questionId} className="my-[8px] w-full">
				<MultipleChoiceQuestion uiConfig={question} />
			</div>
		)
	);

	return <div className="flex flex-col items-start">{mandatoryQuestions}</div>;
};
